var header = document.querySelector(".header-sec");
var toggleClass = "is-sticky";

window.addEventListener("scroll", () => {
    var currentScroll = window.pageYOffset;
    if (currentScroll > 10) {
        header.classList.add(toggleClass);
    } else {
        header.classList.remove(toggleClass);
    }
});

// menu bar
const hamBtn = document.getElementById('hamBtn');
const sidebar = document.getElementById('sidebar');
const overlay = document.getElementById('overlay');
const closeBtn = document.getElementById('closeBtn');

// Open sidebar
hamBtn.addEventListener('click', () => {
    sidebar.classList.add('active');
    overlay.classList.add('active');
});

// Close sidebar
closeBtn.addEventListener('click', () => {
    sidebar.classList.remove('active');
    overlay.classList.remove('active');
});

// Close sidebar when clicking overlay
overlay.addEventListener('click', () => {
    sidebar.classList.remove('active');
    overlay.classList.remove('active');
});


//  doctor slider
const swiper = new Swiper('.testimonialSwiper', {
    slidesPerView: 1,
    spaceBetween: 30,
    loop: true,
    autoplay: {
        delay: 5000,
        disableOnInteraction: false,
    },
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
});

//  ingredientsSwiper slider
const swiperin = new Swiper('.ingredientsSwiper', {
    slidesPerView: 4,
    spaceBetween: 20,
    grabCursor: true,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    breakpoints: {
        0: { // for mobile
            slidesPerView: 1,
            spaceBetween: 16,
        },
        768: { // for tablets and up
            slidesPerView: 3,
            spaceBetween: 20,
        },
        991: { // dasktop view
            slidesPerView: 4,
            spaceBetween: 20,
        },
    },
});

